module.exports = __webpack_public_path__ + "static/media/donovan.5c12e3f2.jpg";